import { render, staticRenderFns } from "./ApproveICRequest.vue?vue&type=template&id=5a73e0cd&scoped=true"
import script from "./ApproveICRequest.vue?vue&type=script&lang=js"
export * from "./ApproveICRequest.vue?vue&type=script&lang=js"
import style0 from "./ApproveICRequest.vue?vue&type=style&index=0&id=5a73e0cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73e0cd",
  null
  
)

export default component.exports